import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import ProductCard from './ProductCard';
import { apiV1 } from '../../../../../../Auth/Interceptor';

function CategoryCollectionList({ item }) {
    const [titleTextSize, setTitleTextSize] = useState(0);
    const [titleLineHeight, setTitleLineHeight] = useState(0);

    const [textSize, setTextSize] = useState(0);
    const [lineHeight, setLineHeight] = useState(0);
    const [sectionGap, setSectionGap] = useState(0);
    const [paddingSide, setPaddingSide] = useState(0);
    const [paddingVert, setPaddingVert] = useState(0);

    const [paddingX, setPaddingX] = useState(0);
    const [paddingY, setPaddingY] = useState(0);

    const [productsList, setProductsList] = useState([]);

    const zoomSize = useSelector((state) => state.storefront.zoomSize);

    useEffect(() => {
        setTitleTextSize((zoomSize/100)*18);
        setTitleLineHeight((zoomSize/100)*30);

        setTextSize((zoomSize/100)*14);
        setLineHeight((zoomSize/100)*26);

        setSectionGap((zoomSize/100)*12);

        setPaddingVert((zoomSize/100)*12);
        setPaddingSide((zoomSize/100)*16);

        setPaddingX((zoomSize/100)*10);
        setPaddingY((zoomSize/100)*9);
    }, [zoomSize]);

    useEffect(() => {
        async function fetchCollectionProducts() {
            try {
                const response = await apiV1.get(`collection/${item.item.categoryCollectionList[0]}`);
                if(response.status === 200) {
                    setProductsList(response.data.data.product);
                }
            }
            catch(err) {
                console.log(err);
            }
        }

        item.item.categoryCollectionList[0] && fetchCollectionProducts();
    }, [item]);

    return (
        <div 
            style={{ gap: `${sectionGap}px`, paddingLeft: `${paddingSide}px`, paddingRight: `${paddingSide}px`, paddingTop: `${paddingVert}px`, paddingBottom: `${paddingVert}px` }} 
            className='flex flex-col relative border border-[#E2E2E2] bg-[#FFFFFF78]'
        >
            <div className="flex items-center justify-between">
                <p style={{ fontSize: `${titleTextSize}px`, lineHeight: `${titleLineHeight}px` }} className='font-medium text-[#212121]'>{item.item.name}</p>
            </div>

            <div className="grid grid-cols-2 gap-x-3 gap-y-3">
                {productsList?.slice(0, 4).map(product => {
                    return (
                        <ProductCard 
                            key={product.id} 
                            product={product} 
                        />
                    )
                })}
            </div>

            <div 
                style={{ paddingLeft: `${paddingX}px`, paddingRight: `${paddingX}px`, paddingTop: `${paddingY}px`, paddingBottom: `${paddingY}px` }} 
                className="w-fit"
            >
                <p style={{ fontSize: `${textSize}px`, lineHeight: `${lineHeight}px` }} className='w-fit font-semibold text-[#F16878]'>See more {">>"}</p>
            </div>
        </div>
    );
}

export default CategoryCollectionList;
